<template>
  <print-dropdown-button
    :buttonLabel="buttonLabel"
    @printClicked="createTemplate">
  </print-dropdown-button>
</template>
<script>
import printMixins from '../../utilities/print/printMixins';
import PrintDropdownButton from '../PrintDropdownButton.vue';

export default {
  name: 'print-tableOnly',
  components: {
    PrintDropdownButton
  },
  props: {
    buttonLabel: String,
    sentGridData: "",
    desiredIds: Array,
    headers: Array,
    title: String,
    hubUUID: String,
  },
  mixins: [printMixins],
  data() {
    return {
      showMenu: false,
    };
  },
  mounted() {

  },
  methods: {
    async createTemplate () {
      let template = [];

      template.push(this.buildPageHeader(this.title));
      template.push(
        {
          style: 'tableExample',
          layout: 'normalTable',
          table: {
            headerRows: 1,
            dontBreakRows: true,
            keepWithHeaderRows: 1,
            body: this.makeTable (this.headers, this.sentGridData, this.desiredIds)
          }
        }
      );

      this.docDefinition['content'] = [template];
      this.docDefinition['footer'] = (currentPage, pageCount) => {    
        return this.buildPageFooter(currentPage, pageCount, this.hubUUID);
      };
      this.pdfMake.createPdf(this.docDefinition).download(this.hubUUID + " - Training Summary.pdf");
    },
  }
};
</script>